<template>
  <div id="app">
    <notifications classes="vue-banner" position="top center" width="960px" group="banner" />
    <app-header />
    <main>
      <section class="bundle-wrapper">
        <div class="bundle">
          <img
            :src="`${$assets}bundle-edu@1x.jpg`"
            :srcset="`${$assets}bundle-edu@2x.jpg 2x`"
            alt="Bundled products photo which includes balls and roller and Magic Circle"
            class="bundle-img"
          />
          <div class="content-wrapper pb-80">
            <div class="content">
              <h3 class="h3 mb-8">Mat 3 Bundle</h3>
              <p class="p3 mb-20">All the props you will need to make your Balanced Body Mat 3 Course a success. Don't forget to bring your own mat to class!</p>
              <h4 class="h mb-8">You get:</h4>
              <a href="https://www.pilates.com/products/magic-foam-exercise-roller" class="content-link">Magic Roller</a>
              <a href="https://www.pilates.com/products/pilates-rings-ultra-fit-circle" class="content-link">Ultra-Fit Circle</a>
              <a href="https://www.pilates.com/products/light-resistance-bands-sissel-fun" class="content-link">Sissel Fun & Active Band</a>
              <a href="https://www.pilates.com/products/inflatable-ball-storm-gray" class="content-link">8"-10" Inflatable Ball</a>
              <a href="https://www.pilates.com/products/balanced-body-pinky-ball" class="content-link mb-20">Pinky Ball</a>
              <div v-if="!isdistcountry">
                <p class="p5">Regular Price: <s>$124</s></p>
                <p class="price">BBE Student Price: $115*</p>
                <p class="p5" style="font-weight:bold">PN: 17327</p>
                <a href="https://www.pilates.com/?quantity=1&id=42721592901825" class="cart-button">Add to Cart</a>
                <p class="p5">*Plus tax &amp; shipping</p>
              </div>
              <div v-if="isdistcountry">
                <p class="p3">Please contact your distributor for pricing information.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
    <div class="contact">
      <a href="mailto:education@pilates.com" class="rnd-btn">Have questions? <span>Email Education Staff.</span></a>
    </div>
    <app-footer />
  </div>
</template>

<script>
import ApiService from "@/js/ApiService.js";
import AppHeader from "@/components/AppHeader.vue";
import AppFooter from "@/components/AppFooter.vue";

export default {
  name: 'App',
  cookieName: 'countrycode',

  components: {
    AppHeader,
    AppFooter
  },

  metaInfo: {
    title: "Exercise Bundles",
    titleTemplate: "%s | Balanced Body",
    meta: [
      {
        description:
          'Buy a bundle and save a bundle! Four bundles to choose from.'
      }
    ]
  },

  data() {
    return {
      countrycode: '',
      defaultcountry: 'world',
      distcountry: {
        'at': true,
        'au': true,
        'be': true,
        'br': true,
        'by': true,
        'cn': true,
        'cr': true,
        'fr': true,
        'de': true,
        'gr': true,
        'hk': true,
        'il': true,
        'it': true,
        'kr': true,
        'kz': true,
        'lu': true,
        'mo': true,
        'nl': true,
        'nz': true,
        'ru': true,
        'es': true,
        'za': true,
        'ch': true,
        'tr': true,
        'ua': true,
        'dk': true,
        'pl': true,
        'th': true,
        'se': true
      },
      bbAffiliateID: ''
    }
  },

  computed: {
    isdistcountry() {
      return this.distcountry[this.countrycode] ? true : false;
    }
  },

  created() {
    this.getGeoCookie(this.$options.cookieName)
    if (!this.countrycode) {
      ApiService.getCountryCode()
      .then(response => {
        this.onSuccess(response);
      })
      .catch(() => {
        this.setGeoCookie(this.$options.cookieName, 'world', '1d');
      })
    }
  },

  mounted() {
    this.isAffiliateRef();
    this.setAffiliateCookie();
  },

  methods: {
    setGeoCookie(cname, cvalue, expire) {
      return this.$cookies.set(cname, cvalue, expire);
    },

    getGeoCookie(cname) {
      const cookieVal = this.$cookies.get(cname);
      return ( cookieVal ? this.countrycode = cookieVal : this.countrycode = '');
    },

    onSuccess(response) {
      if (response.data.haserror === true) {
        this.countrycode = 'world';
        this.setGeoCookie(this.$options.cookieName, 'world', '1d');
      } else {
        this.countrycode = response.data.country_iso.toLowerCase();
        this.setGeoCookie(this.$options.cookieName, this.countrycode, '1d');
      }
    },

    isAffiliateRef() {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      let idString = urlParams.get('bbAffiliateID');
      if ( idString && idString !== "" ) {
        idString = idString.replace(/\D/g,'');
        this.bbAffiliateID = idString;
      }
    },

    setAffiliateCookie() {
      const cookieExists = this.$cookies.isKey("bbAffiliateID");
      if (this.bbAffiliateID && !cookieExists) {
        this.$cookies.set("bbAffiliateID", this.bbAffiliateID, "30d","/",".pilates.com");
      }
    }
  }
}
</script>

<style>
.contact {
  text-align: center;
  margin: 50px 0;
}

a.rnd-btn {
  border: 0.5px solid #919191;
  border-radius: 20px;
  font-family: var(--roboto);
  font-size: 13rem;
  line-height: 1.154;
  text-decoration: none;
  display: inline-block;
  text-align: center;
  color: #555658;
  width: 100%;
  max-width: 310px;
  padding: 10px;
}

a.rnd-btn span {
  font-weight: 700;
  color: var(--emerald);
}

a:hover.rnd-btn span {
  text-decoration: underline;
}

.narrow {
  display: block;
}

.wide {
  display: none;
}

.hero {
  position: relative;
}

.hero-img {
  width: 100%;
  height: 454px;
  object-fit: cover;
  object-position: 40% 50%;
  display: block;
}

.h2 {
  color: var(--white);
}

.headline {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: inline;
  border: 2px solid #e58f6e;
  padding: 20px;
  max-width: 90%;
  white-space: nowrap;
  font-size: 36rem;
}

.notice {
  text-align: center;
  font-style: italic;
  font-weight: 700;
  margin-bottom: -40px;
  margin-top: 20px;
}

.bundle-wrapper {
  background-color: var(--lt-gray);
  padding: 30px;
}

.bundle {
  max-width: 500px;
  margin: 0 auto;
  padding: 30px 0;
}

.bundle-img {
  width: 100%;
  margin-bottom: 20px;
}

.content-link {
  font-family: var(--roboto);
  font-size: 13rem;
  line-height: 1.9;
  font-weight: 400;
  text-decoration: none;
  color: var(--emerald);
  display: block;
}

.content-link:hover,
.content-link:active {
  text-decoration: underline;
}

.mb-8 {
  margin-bottom: 8px
}

.mb-20 {
  margin-bottom: 20px;
}

.mb-60 {
  margin-bottom: -60px;
}

.price {
  font-family: var(--roboto);
  font-size: 13rem;
  line-height: 1.385;
  font-weight: 500;
  color: var(--dk-orange);
}

.price span {
  color: var(--text-gray);
}

.cart-button {
  font-family: var(--roboto);
  font-size: 14rem;
  line-height: 1.143;
  font-weight: 500;
  color: var(--white);
  text-decoration: none;
  display: block;
  padding: 8px;
  width: 165px;
  background-color: var(--green);
  text-align: center;
  margin: 15px 0;
  transition: 0.3s;
}

.cart-button:hover,
.cart-button:active {
  background-color: var(--dk-green);
}

.cta-panel {
  background-image: url('https://s3.amazonaws.com/s3.pilates.com/at-home/pattern-hex.svg');
  background-color: var(--text-gray);
  border-bottom: 2px solid var(--white);
  height: 285px;
}

.flex {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.cta-text {
  font-size: 30rem;
  margin: 0 34px;
  text-align: center;
}

.cta-button {
  font-family: var(--roboto);
  font-weight: 700;
  font-size: 16rem;
  line-height: 1.1875;
  color: var(--text-gray);
  background-color: var(--white);
  padding: 10px 25px;
  border: 2px solid var(--green);
  text-decoration: none;
  margin-top: 25px;
  transition: 0.3s;
}

.cta-button:hover,
.cta-button:active {
  background-color: var(--lt-gray);
}

.vue-banner {
  background-color: #d5e172 !important;
  padding: 25px 45px;
  height: 75px;
  color: #5f6062;
  font-size: 18rem;
  cursor: pointer;
}

.close-btn {
  position: absolute;
  top: 5px;
  right: 10px;
}

@media only screen and (min-width: 768px) {
  .narrow {
    display: none;
  }

  .wide {
    display: block;
  }

  .hero-img {
    height: 530px;
    display: block;
  }

  .headline {
    font-size: 48rem;
  }

  .bundle-wrapper {
    background-color: var(--white);
    width: 100%;
    max-width: 910px;
    margin: 50px auto;
    padding: 0;
  }

  .bundle {
    max-width: none;
    display: grid;
    background-color: var(--white);
    grid-template-columns: 80px auto 420px;
    grid-template-rows: 1fr;
    padding: 0;
  }

  .bundle-img {
    grid-column: 1 / span 2;
    grid-row: 1;
    z-index: 100;
    padding-top: 80px;
    width: 100%;
    max-width: 490px;
  }

  .content-wrapper {
    background-color: var(--lt-gray);
    grid-column: 2 / span 2;
    grid-row: 1;
    padding-top: 80px;
    padding-bottom: 20px;
  }

  .content {
    margin-left: auto;
    margin-right: 80px;
    width: 315px;
  }

  .cta-panel {
    height: 350px;
  }

  .flex {
    padding-top: 60px;
  }

  .cta-text {
    font-size: 36rem;
  }

  .pb-80 {
    padding-bottom: 80px !important;
  }
}
</style>
